module.exports = __webpack_public_path__ + "static/media/CreditBuilder.29e57c94.svg";